import React, { useContext } from "react"
import { graphql, useStaticQuery } from "gatsby"

import FadedTitle from "../shared/faded-title"
import Grid from "../shared/grid"
import IconContent from "./icon-content"
import { UIContext } from "../shared/layout"
import Slider from "react-slick"
import {
  MappedinValuesWrapper,
  ContentWrapper,
  ValuesCardSliderWrapper,
  EmployeePhoto,
} from "./values.style"

const Values = () => {
  const {
    state: { breakpoint },
  } = useContext(UIContext)
  const {
    learnIcon,
    honestIcon,
    customerIcon,
    teamIcon,
    careersFade,
    employeePhotoMobileSrc,
    employeePhotoSrc,
  } = useStaticQuery(graphql`
    query {
      learnIcon: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Desktop/Values Icons/learn_fast.svg"
        }
      ) {
        publicURL
      }
      honestIcon: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Desktop/Values Icons/honest_accountable.svg"
        }
      ) {
        publicURL
      }
      customerIcon: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Desktop/Values Icons/focus_customers.svg"
        }
      ) {
        publicURL
      }
      teamIcon: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Desktop/Values Icons/play_for_team.svg"
        }
      ) {
        publicURL
      }
      careersFade: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Desktop/careers_faded_title.svg"
        }
      ) {
        publicURL
      }
      employeePhotoMobileSrc: file(
        relativePath: { eq: "4_COMPANY/Careers/Mobile/picnic_lunch_mobile.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      employeePhotoSrc: file(
        relativePath: { eq: "4_COMPANY/Careers/Desktop/picnic_lunch.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  return (
    <ContentWrapper>
      <FadedTitle
        title="Mappedin Values"
        image={careersFade.publicURL}
        alt="Careers"
        fadeSettings={{ lg: "center" }}
        textAlign="center"
      />
      <Grid>
        <MappedinValuesCardContainer>
          <IconContent
            icon={learnIcon.publicURL}
            title="Learn Fast"
            description="Making decisions with 70% information. Not being afraid to learn from mistakes."
          />
          <IconContent
            icon={honestIcon.publicURL}
            title="Be Honest &  Accountable"
            description="Share the credit, take the blame."
          />
          <IconContent
            icon={customerIcon.publicURL}
            title="Focus On Customers"
            description="Making decisions based on customer outcomes. Their problems are our problems!"
          />
          <IconContent
            icon={teamIcon.publicURL}
            title="Play for the Team"
            description="Putting the needs of the team first and leading by example."
          />
        </MappedinValuesCardContainer>
      </Grid>
      <EmployeePhoto
        fluid={
          breakpoint === "sm"
            ? employeePhotoMobileSrc.childImageSharp.fluid
            : employeePhotoSrc.childImageSharp.fluid
        }
        alt="Mappedin employees eating a picnic lunch outside at picnic tables."
      />
    </ContentWrapper>
  )
}

export default Values

const MappedinValuesCardContainer = ({ children }) => {
  const {
    state: { breakpoint, clientLoaded },
  } = useContext(UIContext)
  return breakpoint === "sm" && clientLoaded ? (
    <ValuesCardSliderWrapper>
      <Slider dots>{children}</Slider>
    </ValuesCardSliderWrapper>
  ) : (
    <MappedinValuesWrapper>{children}</MappedinValuesWrapper>
  )
}
